import React from 'react';
import ReactPlayer from 'react-player';
import ResponsiveImageMobile from 'components/images/ResponsiveImage';
import AnimatedSingleSquare from 'components/images/AnimatedSingleSquare';
import Fade from 'react-reveal/Fade';

import { BlackSlideMobile, SlideMobile, BigText, Row, MedText, PlayerWrapper } from '../styles';

import { welcomeRotatingImages } from 'data/rotatingImages';

const SectionOneMobile = () => {
  return (
    <React.Fragment>
      <BlackSlideMobile>
        <Fade right>
          <div className="flex-column-center">
            <h1 className="quote">
              ROW DTLA has shown Los Angeles what happens when you redefine the concept of
              workplace, that if you celebrate innovation, collaboration and community, you get
              something very special, that just keeps getting better.
            </h1>
            <span className="scroll-reminder">
              <p>SCROLL</p>
            </span>
          </div>
        </Fade>
      </BlackSlideMobile>
      <Fade>
        <SlideMobile>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_1" />
          <Row paddingBottom="0">
            <BigText className="black-500">
              Welcome to
              <br />
              ROW DTLA
            </BigText>
          </Row>
        </SlideMobile>
      </Fade>
      <SlideMobile>
        <Fade>
          <Row>
            <ResponsiveImageMobile srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_2" />
          </Row>
        </Fade>
        <Fade>
          <Row paddingBottom="0" paddingTop="0">
            <MedText marginTop>
              A 32 acre district with a 100 year old history marks the beginning of LA’s future as
              the new retail, cultural and dining destination. By pairing unique retailers and
              distinct individuals together, a historic area comes to life by way of an elevated
              lifestyle
            </MedText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <PlayerWrapper>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://vimeo.com/357861717"
              playing
              light="/video/player/rowdtla_video_preview_general.jpg"
            />
          </PlayerWrapper>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <Row>
            <ResponsiveImageMobile srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_3" />
          </Row>
        </Fade>
        <Fade>
          <Row paddingBottom="0" paddingTop="0">
            <BigText className="grey-400">
              The revitalization of an urban district happens at the crossroads of creativity and
              culture
            </BigText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <Row paddingBottom="0">
            <ResponsiveImageMobile srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_4" />
          </Row>
        </Fade>
        <Fade>
          <Row paddingBottom="0">
            <MedText marginTop>
              Within an already bustling downtown, ROW infuses even more energy into the
              neighborhood
            </MedText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <AnimatedSingleSquare imgArray={welcomeRotatingImages} active />
        <Fade>
          <Row paddingBottom="2.5em">
            <ResponsiveImageMobile srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_17" />
          </Row>
        </Fade>
        <Fade>
          <Row paddingBottom="2.5em" paddingTop="0">
            <MedText marginTop>
              An international and local blend of like-minded artists, designers, chefs and
              merchants interacting together in a walkable work, shop, eat and play community.
            </MedText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <Row paddingBottom="2.5em">
            <ResponsiveImageMobile srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_18" />
          </Row>
        </Fade>
      </SlideMobile>
    </React.Fragment>
  );
};

export default SectionOneMobile;
